





import {
  defineComponent,
} from '@vue/composition-api';

import PageColumnWithCustomerEditor from '@/components/Customer/PageColumnWithCustomerEditor.vue';

const Edit = defineComponent({
  // setup() {},
  components: {
    PageColumnWithCustomerEditor,
  },
});

export default Edit;
